import React from 'react';
import { Link } from 'react-router-dom';
import PropType from 'prop-types';
import AsyncSelect from 'react-select/lib/Async';
import axios from 'axios';

import './ViolinPlot.css';

const apiHost = process.env.REACT_APP_API_HOST;
const apiProto = process.env.REACT_APP_API_PROTOCOL;

const fetchOptions = (inputValue) => {
  const url = `${apiProto}://${apiHost}/single-cell/gene_list?filter=${inputValue}`;
  return axios.get(url).then((response) => {
    const options = response.data.map(item => ({ value: item.value, label: item.label }));
    return options;
  });
};

class ViolinPlot extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      geneList: { value: '' },
      logScale: false,
    };
  }

  handleSubmit = () => {
    const { match, cellPopulation } = this.props;
    // grab all values from the form state.
    const gene = this.state.geneList.value;
    const { logScale } = this.state;
    // clear out the form for future searches?
    // validation here??
    const payload = {
      type: 'violinplot',
      category: 'singlecell',
      gene,
      logScale,
      ord: cellPopulation.get('chosen'),
    };
    // submit values to the backend storage and retrieve the uuid
    axios.post(`${apiProto}://${apiHost}/search`, payload).then((response) => {
      // redirect to the results page which will load in the image and parameters.
      const redirect = `${match.path}/${response.data}`;
      this.props.history.push(redirect);
    });
  }

  handleChange = (event) => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  }

  render() {
    // TODO: finish the gene list auto select drop down based on code from:
    // ${apiProto}s://deploy-preview-2289--react-select.netlify.com/home
    return [
      <div className="row" key="selection">
        <div className="col-md-9">
          <div className="form-group">
            <label htmlFor="geneList">Gene <Link to="/about#geneselection">?</Link></label>
            <AsyncSelect
              placeholder="Start typing to load gene options"
              noOptionsMessage={() => "No options, please use a less specific filter string. Still can't find your gene of interest? Please see our methods section, by clicking on the '?' next to this search box."}
              loadOptions={fetchOptions}
              name="geneList"
              value={this.state.geneList}
              onChange={value => this.setState({ geneList: value })}
            />
          </div>
        </div>
        <div className="col-md-3 logContainer">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              name="logScale"
              checked={this.state.logScale}
              onChange={this.handleChange}
              id="logScale"
            />
            <label className="form-check-label" htmlFor="logScale">
              Log scale
            </label>
          </div>
        </div>
      </div>,
      <div className="row" key="submition">
        <div className="col">
          <button className="btn btn-primary" onClick={this.handleSubmit}>Submit</button>
        </div>
      </div>,
    ];
  }
}

ViolinPlot.propTypes = {
  match: PropType.object.isRequired,
  history: PropType.object.isRequired,
  cellPopulation: PropType.object.isRequired,
};

export default ViolinPlot;



// WEBPACK FOOTER //
// ./src/components/SingleCell/ViolinPlot.jsx